import { fork } from 'redux-saga/effects';
import channelsSagas from './channels';
import filtersSagas from './filters';
import invitePatientSagas from './invitePatient';
import metadataSagas from './metadata';
import selectNextTargetUserSagas from './selectNextTargetUser';
import relatedUsersWorkerSaga from './relatedUsers';
import participants from './participants';
import assignProviderSaga from './assignProvider';
import removeContextUserSaga from './removeContextUser';
import handleUserBlockedSaga from './handleBlockedUsers';
import updateChatSaga from './updateChatSaga';
import sendMessageWithInboxTaskSaga from './send-message-with-inbox-task-saga';

export default function* root() {
  yield fork(channelsSagas);
  yield fork(filtersSagas);
  yield fork(invitePatientSagas);
  yield fork(metadataSagas);
  yield fork(selectNextTargetUserSagas);
  yield fork(relatedUsersWorkerSaga);
  yield fork(participants);
  yield fork(assignProviderSaga);
  yield fork(removeContextUserSaga);
  yield fork(handleUserBlockedSaga);
  yield fork(updateChatSaga);
  yield fork(sendMessageWithInboxTaskSaga);
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/index.js